export type Rarity = 'common' | 'uncommon' | 'obscure';

export interface ValidWord {
  word: string;
  prefix: string;
  suffix: string;
  rarity: Rarity;
  definition: string;
}

export interface MorphemeRaw {
  text: string;
}

export interface RootwordsLevel {
  root?: string;
  rootMeaning?: string;
  prefixes?: MorphemeRaw[];
  suffixes?: MorphemeRaw[];
  validWords?: Array<{
    word?: string;
    prefix?: string;
    suffix?: string;
    rarity?: string;
    definition?: string;
  }>;
  targetCount?: number;
  bonusThreshold?: number;
}

export interface NormalizedRootwords {
  root: string;
  rootMeaning: string;
  prefixes: string[];
  suffixes: string[];
  validWords: ValidWord[];
  targetCount: number;
  bonusThreshold: number;
}

export function normalizeRootwords(level: RootwordsLevel): NormalizedRootwords | null {
  const root = (level.root ?? '').toUpperCase();
  if (!root) return null;
  const prefixes = (level.prefixes ?? [])
    .map((p) => (p.text ?? '').toUpperCase())
    .filter(Boolean);
  const suffixes = (level.suffixes ?? [])
    .map((p) => (p.text ?? '').toUpperCase())
    .filter(Boolean);
  const valid: ValidWord[] = (level.validWords ?? [])
    .map((v) => ({
      word: (v.word ?? '').toUpperCase(),
      prefix: (v.prefix ?? '').toUpperCase(),
      suffix: (v.suffix ?? '').toUpperCase(),
      rarity: (v.rarity as Rarity) ?? 'common',
      definition: v.definition ?? '',
    }))
    .filter((v) => v.word.length > 0);
  if (prefixes.length === 0 || suffixes.length === 0 || valid.length < 3) return null;
  const targetCount = level.targetCount ?? Math.max(5, Math.floor((valid.length * 7) / 10));
  const bonusThreshold = level.bonusThreshold ?? valid.length;
  return {
    root,
    rootMeaning: level.rootMeaning ?? '',
    prefixes,
    suffixes,
    validWords: valid,
    targetCount,
    bonusThreshold,
  };
}
